module.exports = __webpack_public_path__ + "img/gs1.c6fa50e6.png";